__turbopack_context__.v({
  "advertisedOnLogos": "AdvertisedOnSection-module__wtCYza__advertisedOnLogos",
  "advertisedOnText": "AdvertisedOnSection-module__wtCYza__advertisedOnText",
  "container": "AdvertisedOnSection-module__wtCYza__container",
});
